import React from 'react';
import TranslatedComponent from '../../utils/TranslatedComponent';
import {secureReplace, redirectToLogin, callTealiumLink} from '../../utils/helpers';

class MobileAccountInfo extends React.Component {
  constructor(props) {
    super(props);

    this.accountClick = this.accountClick.bind(this);
    this.logoutClick = this.logoutClick.bind(this);
  }

  accountClick() {
    callTealiumLink({event_name: 'linkClick', link_category: 'oneIdWeb', 'link_name': 'Account' });
    window.did.launchProfile()
      // This API returna a Promise object (thenable)
      // the first function passed to then() is success(data)
      .then(function(data) {})
      // the second function is an error handler (optional)
      .fail(function(error) {
        console.log("Looks like there was a problem launching account info. ", error);
      });
  }

  logoutClick () {
    callTealiumLink({event_name: 'linkClick', link_category: 'oneIdWeb', 'link_name': 'Logout' });
    window.did.logout()
    // this API returns a Promise object (thenable)
    // the first function passed to then() is success(data)
      .then(function(data){
        // Redirect back to the anonymous page
        window.location.href = redirectToLogin();
      })
      // the second function is an error handler (optional)
      .fail(function(error){
        console.log("Looks like there was a problem logging out. ", error);
      });
  }

  render() {
    var classNames = ['mobileAccountInfoContainer'];
    if (this.props.visible) {
      classNames.push('fadein');
    } else {
      classNames.push('fadeout');
    }

    var welcome = secureReplace(this.translate('welcomeText'), 'name', this.props.name);
    return (
      <div className={classNames.join(' ')}>
        <p id='welcomeGuestName-mobileHeaderGreeting'>{welcome}</p>
        <span className='mobileAccountInfoLinks'>
          <a id='myAccount-mobileHeaderLink' onClick={this.accountClick}>{this.translate('accountLink')}</a>
          <span className='pipe'>|</span>
          <a id='signOut-mobileHeaderLink' onClick={this.logoutClick}>{this.translate('signOutLink')}</a>
        </span>
      </div>
    );
  }
}

TranslatedComponent(MobileAccountInfo);
module.exports = MobileAccountInfo;



// WEBPACK FOOTER //
// ./client/src/components/header/MobileAccountInfo.jsx